// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__b63t-","mainHeader":"Header_mainHeader__FqL0m","imgContainer":"Header_imgContainer__hXLpY"};